var noop = require('lodash/noop');

/*
  The chrome browser has recently added support for media keyboard events.
  We want to ignore these because when our player is loaded within a chrome tab,
  this could have confusing consequences.

  This does not affect the desktop app keyboard shortcuts.

  https://developer.mozilla.org/en-US/docs/Web/API/Media_Session_API
*/
function ignoreChromeMediaEvents() {
  if ('mediaSession' in navigator) {
    // override chrome events so that playback is not unintentionally interrupted
    navigator.mediaSession.setActionHandler('play', noop);
    navigator.mediaSession.setActionHandler('pause', noop);
    navigator.mediaSession.setActionHandler('seekbackward', noop);
    navigator.mediaSession.setActionHandler('seekforward', noop);
    navigator.mediaSession.setActionHandler('previoustrack', noop);
    navigator.mediaSession.setActionHandler('nexttrack', noop);
  }
}

module.exports = ignoreChromeMediaEvents;
